// extracted by mini-css-extract-plugin
export default {"form-text":"PhoneAndEmailScreen_form-text__Sim+o","form-body":"PhoneAndEmailScreen_form-body__A6XoI"};